import React from 'react';
import { useParams } from 'react-router-dom';
import { ApproveClientReportForm } from 'modules/components/layer12';
import { BasicFormModalLayout } from 'modules/components/layer13';

export type ApproveClientReportModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

export const FC = (props: ApproveClientReportModalProps) => {
  const params = useParams();
  return (
    <BasicFormModalLayout.FC
      id={props.id}
      title='Approve client report'
      subTitle='Send to client. This can not be undone.'
      handleClose={props.handleClose}
      isVisible={props.isVisible}
    >
      <ApproveClientReportForm.FC
        id={props.id}
        projectId={params.projectId ?? ''}
        handleClose={props.handleClose}
      />
    </BasicFormModalLayout.FC>
  );

};
